export const COMMUNITIES_ROWS = 25
